/**
 * Buy More Save More — tier progress bar.
 *
 * This file mutates nothing. All the counting lives in
 * snippets/cart-tier-progress.liquid, exactly as cart-free-gift.js keeps its
 * math server-side, so the bar can never disagree with what Liquid decided and
 * therefore never disagrees with the Function that applies the discount.
 *
 * Its only job is keeping the drawer copy current. m-cart-drawer's
 * onCartDrawerUpdate() re-renders four selectors and this module sits in the
 * drawer header, which is not one of them — so without this it would show
 * whatever state the page was loaded with. (The cart page is fine: mutations
 * there do a full reload.)
 *
 * WHY A SECOND FETCH RATHER THAN SHARING cart-free-gift.js's. The two modules
 * are kept independent on purpose, the same way ic-landing.js and
 * cart-free-gift.js are: an edit to the charm flow must not be able to break
 * the tier bar mid-campaign, and vice versa. The cost is one extra section
 * fetch per cart update, which is a few hundred bytes.
 */
(function syncTierProgress() {
  if (window.__mTierProgressSync) return;
  window.__mTierProgressSync = true;

  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let refreshing = false;
  let queued = false;

  async function refreshRoot() {
    const root = document.querySelector('m-cart-drawer [data-tier-progress-root]');
    if (!root) return;

    // Cart updates can arrive faster than the fetch resolves (a shopper holding
    // the quantity stepper). Coalesce them: run once more after the in-flight
    // request lands, so the bar ends on the true final state rather than an
    // intermediate one.
    if (refreshing) {
      queued = true;
      return;
    }

    refreshing = true;
    try {
      const response = await fetch(`${rootUrl}?section_id=cart-drawer`);
      const markup = await response.text();
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const fresh = parsed.querySelector('[data-tier-progress-root]');

      // innerHTML (not replaceWith) so the anchor survives and can repopulate
      // later, including from an empty cart.
      root.innerHTML = fresh ? fresh.innerHTML : '';
    } catch (error) {
      /* leave the stale render in place rather than blanking the module */
    } finally {
      refreshing = false;
      if (queued) {
        queued = false;
        refreshRoot();
      }
    }
  }

  function subscribe() {
    if (!window.MinimogEvents || !window.MinimogTheme) return false;
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, refreshRoot);
    return true;
  }

  if (!subscribe()) {
    document.addEventListener('DOMContentLoaded', subscribe, { once: true });
  }
})();
